import { throttle } from 'lodash';
import { useLayoutEffect, useMemo, useState } from 'react';
import { system } from 'styled-system';
import { findMatchMedia } from './findMatchMedia';
import { useTheme } from '../useTheme';
export const useBreakpoint = () => {
    const theme = useTheme();
    const matchMedias = useMemo(() => {
        const breakpointObj = Object.keys(theme.breakpoints)
            .filter((v) => Number.isNaN(parseInt(v, 10)))
            .reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: key })), {});
        const breakpointArr = system({
            breakpoint: true,
        })({
            breakpoint: breakpointObj,
            theme,
        });
        return Object.keys(breakpointArr).map((query) => ({
            breakpoint: breakpointArr[query].breakpoint,
            matchMedia: window.matchMedia(query.replace('@media ', '')),
            query,
        }));
    }, [theme]);
    const [breakpoint, setBreakpoint] = useState(() => findMatchMedia(matchMedias));
    useLayoutEffect(() => {
        setBreakpoint(findMatchMedia(matchMedias));
        const calcInnerWidth = throttle(() => {
            setBreakpoint(findMatchMedia(matchMedias));
        }, 200);
        window.addEventListener('resize', calcInnerWidth);
        return () => {
            window.removeEventListener('resize', calcInnerWidth);
        };
    }, [matchMedias]);
    return breakpoint;
};
//# sourceMappingURL=useBreakpoint.js.map